import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { Col, Grid, Row } from "antd";

const { useBreakpoint } = Grid;

export function JourneyIntroduction({ introducing_you_to_royal_air = {} }) {
	const screens = useBreakpoint();
	return (
		<Container style={{ paddingBottom: 60 }}>
			<Row align="top" gutter={[12, 12]}>
				<Col xxl={8} xl={10} md={10} sm={12} xs={24}>
					<WrapperMain className={`${"animate__animated animate__fadeInDown"}`}>
						<RATypography variant={screens?.xs ? "h4" : "h2"}>
							{introducing_you_to_royal_air?.title || ""}
						</RATypography>
					</WrapperMain>
				</Col>
				<Col xxl={16} xl={14} md={14} sm={12} xs={24}>
					<RATypography variant="body3" color="#595959">
						{introducing_you_to_royal_air?.description || ""}
					</RATypography>
				</Col>
			</Row>
		</Container>
	);
}

const Container = styled.div`
	width: 100%;
	padding: 80px 0;
	@media (max-width: 575px) {
		padding: 0;
	}
`;

const WrapperMain = styled.div`
	padding: 4px 12px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
